import Axios from "axios";
import { useHistory } from "react-router-dom";

const INITIAL_STATE = {
  partnerDetails: {},
};

export const updatePartnerDetails = param => ({
  type: "SET_PARTNERS_DETAILS",
  payload: param,
});

export const getPartnerDetails = (url, config, history) => (dispatch, getState) => {
  return Axios.get(url, config)
    .then(resp => {
      dispatch(updatePartnerDetails(resp.data));
    })
    .catch(function (error) {
      history.push("/404");
    });
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_PARTNERS_DETAILS":
      return { ...state, partnerDetails: action.payload };
    default:
      return state;
  }
};
